<template>

  <div>
    <div style="width: 100%;">
      <img src="../../productAndService/banner_01.png" alt="产品与服务" style="width: 100%; height: auto;">
    </div>

    <!-- 头部切换 -->
    <div class="wd100 pdtop" style="width: 1255px;margin: 40px auto;position: relative">
      <div class="breadcrumb">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb-list">
            <li class="breadcrumb-item"><a @click="active('/')">首页></a></li>
            <li class="breadcrumb-item"><a href="#">产品与服务></a></li>
            <li class="breadcrumb-item">项目申报</li>
          </ol>
        </nav>
      </div>
      <div class="navigation">
        <div class="navigation-title">项目申报</div>
        <div class="navigation-links" style="text-align: center">
          <a style="margin-left: 250px" href="#" class="navigation-link" :class="{ active: activeLink === 'patent' }"
             @click.prevent="selectLink('patent')">国家级科技项目</a>
<!--          <span class="separator">|</span>-->
<!--          <a href="#" class="navigation-link" :class="{ active: activeLink === 'trademark'  }"-->
<!--             @click.prevent="selectLink('trademark')">省级政府扶持项目</a>-->
<!--          <span class="separator">|</span>-->
<!--          <a href="#" class="navigation-link" :class="{ active: activeLink === 'copyright' }"-->
<!--             @click.prevent="selectLink('copyright')">省级科技项目</a>-->
<!--                    <span class="separator">|</span>-->
<!--                    <a href="#" class="navigation-link" :class="{ active: activeLink === 'software' }" @click.prevent="selectLink('software')">州级市级科技项目</a>-->
        </div>
      </div>
    </div>


    <!--专利申请start******************************************************************************************************************************************************************************-->
    <div v-show="patentShow">
      <div class="wd100 pdtop pdtopStyle" style="height: 2350px">
        <div>
        <span class="titleSty">项目申报介绍
        <span class="spanSty">Introduce</span></span>
        </div>
        <div class="container1">
          <div class="text-container">
            <div class="text-containerdiv">
              <p class="pstyle2">
                &nbsp;&nbsp;&nbsp;&nbsp;项目申报是指政府机关针对企业或其他研究单位作出的一系列优惠政策，企业或相关研究单位再
                根据政府的政策进行编写申报文件然后根据相关申报要求和流程进行申报。可申请的项目包括国家省
                项目申报
                市资助计划体系及各部委资助计划比如863计划，973计划，科技型中小企业创新基金，中小企业发
                展专项资金，企业科技新技术，国家社科基金，国家自科基金，省社科基金、省自科基金等不同级别
                的项目，申请时难度不同，申请人的资格和条件也各有不同。随着我国财政支持资金渠道的增多，企
                业申报的财政支持项目越来越多。但是，仍有很多企业仍不熟悉申报程序，经常出现符合申报条件的
                落实培育发展高新技术企业政策
                项目漏报、或者报了没有把握好申报要求，在具备条件的情况下享受不到国家扶持政策，针对这些问
                题，我们安贝森科服能给出最专业的解决方案。
              </p>
            </div>
          </div>
          <div class="image-container2">
            <img src="./gj001.png" alt="Image Description" style="margin-top: -65px;position: absolute;">
          </div>
        </div>

        <!--版权申请的好处及作用-->
        <div style="position: absolute;margin-top: 350px;width: 1255px">
        <span class="titleSty">项目申报的好处
        <span class="spanSty">Advantage</span></span>
          <div class="advantage-container">
            <div class="service-block">
              <img src="./gj002.png" alt="服务经验" class="advantage-icon-gj">
              <p class="advantage-desc">服务经验</p>
            </div>
            <div class="service-block">
              <img src="./gj003.png" alt="资金补贴" class="advantage-icon-gj">
              <p class="advantage-desc">资金补贴</p>
            </div>
            <div class="service-block">
              <img src="./gj004.png" alt="品牌提升" class="advantage-icon-gj">
              <p class="advantage-desc">品牌提升</p>
            </div>
            <div class="service-block">
              <img src="./gj005.png" alt="扶持倾斜" class="advantage-icon-gj">
              <p class="advantage-desc">扶持倾斜</p>
            </div>
            <div class="service-block">
              <img src="./gj006.png" alt="上市优先" class="advantage-icon-gj">
              <p class="advantage-desc">上市优先</p>
            </div>
          </div>
        </div>

        <!--申报条件-->
        <div style="position: absolute;margin-top: 715px;width: 707px">
          <span class="titleSty">国家级科技项目申报条件
          <span class="spanSty">Declaration conditions</span></span>
        </div>
        <div style="width: 1215px;position: absolute; margin-top: 775px;">
           <p class="pstyle2">1、具有较强科研能力和条件、运行管理规范、在中国大陆境内注册、具有独立法人资格的科研机构、高等学校、企业等，可根据项目申报指南要求申报项目。多个单位组成申
             报团队联合申报的，应签订联合申报协议，并明确一家单位作为项目牵头单位。项目下设课题的，也应同时明确课题承担单位。
           </p>
           <p class="pstyle2">2、申报项目应明确项目（课题）负责人。项目（课题）负责人应具有领导和组织开展创新性研究的能力，科研信用记录良好，年龄、工作时间等符合指南要求。项目（课题）
             负责人及研发骨干人员按相关规定实行限项管理。
           </p>
        </div>


        <!--申报流程-->
        <div style="position: absolute;margin-top: 970px;width: 1255px">
          <span class="titleSty">国家级科技项目申报流程
          <span class="spanSty">Declaration process</span></span>
        </div>
        <div style="width: 1255px;position: absolute; margin-top: 1050px;">
          <div class="process-container">
            <img src="./gj007.png" alt="背景图片" class="process-background-image">
            <div class="step step1">明确项目目标与定位</div>
            <div class="step step2">提交申报材料</div>
            <div class="step step3">答辩与评审</div>
            <div class="step step4">项目实施</div>
            <div class="step step5">项目验收与评估</div>
            <div class="step step6">编制项目建议书</div>
            <div class="step step7">形式审查与初评</div>
            <div class="step step8">公示与签约</div>
            <div class="step step9">项目管理</div>
          </div>
        </div>


        <!--服务流程-->
        <div style="position: absolute;margin-top: 1300px;width: 1255px">
          <span class="titleSty">服务流程
          <span class="spanSty">Service process</span></span>
        </div>
        <div style="width: 1255px;position: absolute; margin-top: 1381px;">
          <div class="flowchart-container-updated">
            <img src="./gj008.png" alt="流程图背景" class="flowchart-background-updated">
            <div class="step-texts-updated">
              <div class="step-text step1-updated">全方位咨询顾问</div>
              <div class="step-text step2-updated">一对一专家服务</div>
              <div class="step-text step3-updated">资料准备</div>
              <div class="step-text step4-updated">申报后全程跟进</div>
              <div class="step-text step5-updated">认定后跟踪服务</div>
              <div class="step-text step6-updated">办理完成</div>
            </div>
          </div>
        </div>

        <div style="position: absolute;margin-top: 1620px;width: 707px">
          <span class="titleSty">安贝森优势
          <span class="spanSty">Our advantage</span></span>
        </div>
        <AdvantageList  customStyle="position: absolute;margin-top: 1680px;width: 1200px;margin-left: -25px;" />

      </div>
    </div>
    <!--专利申请end******************************************************************************************************************************************************************************-->


    <!--商标注册start*******************************************************************************************************************************************************************************-->
    <div v-show="trademarkShow">

    </div>
    <!--商标注册end*******************************************************************************************************************************************************************************-->


    <!--版权登记******************************************************************************************************************************************************************************-->
    <div v-show="copyrightShow">

    </div>
    <!--版权登记******************************************************************************************************************************************************************************-->

    <div class="wd100 pdtop" style="width: 1255px;margin: 0px auto;height:150px">
    </div>
  </div>


</template>
<style scoped>
@import 'projectApplication.css';
</style>
<script>
import AdvantageList from '../common/advantageList2.vue';

export default {
  components: {AdvantageList},
  data() {
    return {
      activeLink: 'patent',
      patentShow: true,
      trademarkShow: false,
      copyrightShow: false,
      softwareShow: false,
    }
  },

  methods: {
    selectLink(link) {

      // 重置所有模块的显示状态为 false
      this.patentShow = false;
      this.trademarkShow = false;
      this.copyrightShow = false;
      this.softwareShow = false;

      // 根据点击的链接设置对应模块的显示状态为 true
      if (link === 'patent') {
        this.patentShow = true;
      } else if (link === 'trademark') {
        this.trademarkShow = true;
      } else if (link === 'copyright') {
        this.copyrightShow = true;
      } else if (link === 'software') {
        this.softwareShow = true;
      }

      this.activeLink = link; // 更新当前选中的链接

    },
  },
  mounted: function () {

  },
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/service/projectApplication/projectApplication.vue